import { Button, DatePicker, Form, Input, InputNumber, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { getData, postData, putData } from "../../utils";
import { useLoaderProvider } from "../../context/LoaderProvider";
import moment from "moment";
import { useNotification } from "../../context/NotificationProvider";
import { errorMsg } from "../../utils/errorMsg";
import dayjs from "dayjs";
const AddDiscountCodes = ({ isOpen = false, onCancel = () => {}, editId = 0, callback = () => {} }) => {
  const [payload, setPayload] = useState({ name: "", endDate: "", type: "", flatAmount: "" });
  const [isDisabled, setIsDisabled] = useState(true);
  const { updateLoader } = useLoaderProvider();
  const { openNotification } = useNotification();
  const [form] = Form.useForm();
  const [couponStripeId, setCouponStripeId] = useState("");

  const getEditRecord = async () => {
    updateLoader(true);
    try {
      let res = await getData(`/v1/admin/coupon/get-single-coupon-record/${editId}`);
      let data = res.data;
      setCouponStripeId(data.coupon_stripe_id);
      let obj = {
        name: data.name,
        endDate: moment(data.end_date),
        type: data.type,
        flatAmount: parseFloat(data.flat_amount),
        coupon_stripe_id: data.coupon_stripe_id,
      };
      form.setFieldsValue(obj);
      setPayload(obj);
    } catch (e) {}
    updateLoader(false);
  };

  useEffect(() => {
    if (editId !== 0) {
      getEditRecord();
    } else {
      setPayload({
        name: "",
        endDate: "",
        type: "",
        flatAmount: "",
      });
    }
  }, [editId]);

  useEffect(() => {
    let required = ["name", "type", "flatAmount"];
    for (let i of required) {
      if (i === "flatAmount" && !/^-?\d+(\.\d+)?$/.test(payload[i])) {
        setIsDisabled(true);
        break;
      } else if (!payload[i]) {
        setIsDisabled(true);
        break;
      }
    }

    return () => {
      setIsDisabled(false);
    };
  }, [payload]);

  const submit = async () => {
    updateLoader(true);
    let body = JSON.stringify({
      ...payload,
      endDate: payload.endDate ? dayjs(payload.endDate).format("YYYY-MM-DD") : null,
    });
    if (editId === 0) {
      try {
        let s = await postData("/v1/admin/coupon/add", body);
        openNotification(s.message);
        callback();
      } catch (e) {
        let d = errorMsg(e);
        openNotification(d.message);
      }
    } else {
      try {
        let s = await putData(
          `/v1/admin/coupon/update/${editId}/${couponStripeId}`,
          JSON.stringify({
            name: payload.name,
          })
        );
        openNotification(s.message);
        callback();
      } catch (e) {
        let d = errorMsg(e);
        openNotification(d.message);
      }
    }

    updateLoader(false);
  };

  return (
    <>
      <Modal
        title={`${editId === 0 ? "Add" : "Edit"} Discount codes`}
        centered
        open={isOpen}
        onCancel={onCancel}
        footer={null}
      >
        <Form
          name="my_form"
          layout="vertical"
          initialValues={payload}
          onValuesChange={(changedValues, allValues) => {
            setPayload((prev) => ({ ...prev, ...allValues }));
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
          form={form}
        >
          <Form.Item
            label="Unique code name"
            name="name"
            rules={[
              {
                required: true,
                message: "Please enter your Unique code name",
              },
              { pattern: /[a-zA-Z0-9]$/, message: "No space allowed" },
            ]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item label="End date" name="endDate">
            <DatePicker
              disabledDate={(current) => current && current < moment().endOf("day")}
              disabled={editId === 0 ? false : true}
              className="w-full h-[39px]"
            />
          </Form.Item>
          <Form.Item
            label="Code type"
            name="type"
            rules={[
              {
                required: true,
                message: "Please select your Code type",
              },
            ]}
          >
            <Select
              className="h-[39px]"
              options={[
                {
                  value: "once",
                  label: "One time",
                },
                {
                  value: "everytime",
                  label: "Everytime",
                },
              ]}
              disabled={editId === 0 ? false : true}
            />
          </Form.Item>
          <Form.Item
            label="Flat amount"
            name="flatAmount"
            rules={[
              {
                required: true,
                message: "Please enter your Flat amount",
              },
              {
                pattern: new RegExp(/^\d+(\.\d+)?$/),
                message: "Only numbers and decimal allowed",
              },
            ]}
          >
            <Input size="large" disabled={editId === 0 ? false : true} />
          </Form.Item>
          <div className="flex justify-end">
            <Button type="primary" disabled={isDisabled} onClick={submit} htmlType="submit">
              {editId !== 0 ? "Edit" : "Add"}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default AddDiscountCodes;
